import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { getConfiguratorTitle } from '@/shared/lib/configurator';
import styles from './title.module.css';

export const Title = () => {
	const { state } = useConfigurator();
	const title = getConfiguratorTitle(state);

	return <p className={styles.title}>{title}</p>;
};
